export type BlogPlacements = { featuredPostId: string | null; pinnedPostIds: string[] };
export type BlogPlacementAction = "feature" | "unfeature" | "pin" | "unpin" | "move_up" | "move_down";
export const emptyBlogPlacements: BlogPlacements = { featuredPostId: null, pinnedPostIds: [] };

/** Filter newest-first posts before splitting; only an explicit matching feature opens What's hot. */
export function splitBlogFeed<T extends { id: string }>(posts: T[], placements: BlogPlacements) {
  const featured = posts.find(post => post.id === placements.featuredPostId);
  const pinned = placements.pinnedPostIds.flatMap(id => posts.find(post => post.id === id && post.id !== featured?.id) || []);
  const selectedIds = new Set([featured?.id, ...pinned.map(post => post.id)]);
  return { featured, pinned, remaining: posts.filter(post => !selectedIds.has(post.id)) };
}
